/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    pre: "pre",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "样式对象(Style Objects)"
    }), "\n", _jsx(_components.p, {
      children: "¥Style Objects"
    }), "\n", _jsx(_components.p, {
      children: "styled-components 可以选择支持将 CSS 编写为 JavaScript 对象而不是字符串。当你拥有现有样式对象并希望逐渐转向样式化组件时，这特别有用。"
    }), "\n", _jsx(_components.p, {
      children: "¥styled-components optionally supports writing CSS as JavaScript objects instead of strings. This is particularly useful when you have existing style objects and want to gradually move to styled-components."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// Static object\nconst Box = styled.div<{ $background?: string; }>({\n  background: '#BF4F74',\n  height: '50px',\n  width: '50px'\n});\n\n// Adapting based on props\nconst PropsBox = styled.div(props => ({\n  background: props.$background,\n  height: '50px',\n  width: '50px'\n}));\n\nrender(\n  <div>\n    <Box />\n    <PropsBox $background=\"blue\" />\n  </div>\n);\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
